import { SecurityService } from '../../../services/security';
import { RaporApiBase } from '../../core/ApiBase';

export default class KiraIcmalRapor extends RaporApiBase {
  constructor() {
    super();
    this._MethodUrl = SecurityService.URLSafeParams([{ name: 'RaporTuru', value: 'KiraIcmalRapor' }]);
  }
}
